const Component = () => {
  return <>404</>;
};

export default Component;
